import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetCategoryPickerResponse } from '@/api/handlers/resources/categories/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { CategoryQueryKeys } from './categoryQueryKeys';

/**
 * Reads `GET /categories/picker` (BOS-83) — the full, flat, unpaginated
 * category list for form dropdowns / selects and import name-matching. The
 * management table stays on `/categories/tree` (it needs the hierarchy); any
 * UI that just needs *all* categories should use this instead.
 */
export const useCategoryPickerQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetCategoryPickerResponse>>({
        queryKey: CategoryQueryKeys.picker(),
        queryFn: () => apiClient.categories.getCategoryPicker(),
        enabled,
        staleTime: 60_000,
    });
};
